module.exports = __webpack_public_path__ + "img/Ice Cream Berries.44e371ae.png";